import script from "./PieChart.vue?vue&type=script&setup=true&lang=ts"
export * from "./PieChart.vue?vue&type=script&setup=true&lang=ts"

import "./PieChart.vue?vue&type=style&index=0&id=07491def&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07491def"]])

export default __exports__